import { GestionarContactosInformeDialogComponent } from 'src/app/presentation/shared/contactos/gestionar-contactos-informe-dialog.component';
import { gestionContactosInformeSiAplica } from 'src/app/presentation/shared/contactos/contactos-informe.utils';
import {
  Component,
  OnInit,
  inject,
  signal,
  ChangeDetectorRef,
  computed,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import {
  BusquedaAsesorDialogComponent,
  AsesorFiltro
} from '../common/busquedas/busqueda-asesor-dialog.component';
import {
  BusquedaClienteDialogComponent,
  ClienteSeleccionado
} from '../common/busquedas/busqueda-cliente-dialog.component';
import {
  BusquedaTareaDialogComponent,
  TareaSeleccionada
} from '../common/busquedas/busqueda-tarea-dialog.component';
import { BusquedaUnidadAdministrativaDialogComponent, UnidadAdministrativaSeleccionada } from '../shared/buscadores/buscador-unidad-administrativa-dialog.component';
import {
  BusquedaCentroTrabajoDialogComponent,
  CentroTrabajoSeleccionado
} from '../common/busquedas/busqueda-centro-trabajo-dialog.component';
import {
  BusquedaAseguradoraDialogComponent,
  AseguradoraSeleccionada
} from '../shared/buscadores/buscador-aseguradora-dialog.component';
import { AsesorSeleccionado } from '../common/busquedas/busqueda-asesor-dialog.component';
import {
  sanitizeText,
  sanitizeTextPreserveSpaces
} from 'src/app/common/input-utils';
import { FormularioCumplimientoComponent } from '../cumplimientos/components/formulario-cumplimiento/formulario-cumplimiento.component';
import { HistorialCumplimientosDialogComponent } from '../cumplimientos/components/historial-cumplimientos-dialog/historial-cumplimientos-dialog.component';
import { AgendaRepository } from 'src/app/domain/service/agenda/agenda-repository';
import {
  Persona,
  getNombreCompleto
} from 'src/app/domain/model/persona/persona';
import { PersonaRepository } from 'src/app/domain/service/persona/persona-repository';
import { Oficina } from 'src/app/domain/model/oficina/oficina';
import { OficinaRepository } from 'src/app/domain/service/oficina/oficina-repository';
import { CumplimientoRepository } from 'src/app/domain/service/cumplimiento/cumplimiento-repository';
import { OrdenNoProgramadaRepository } from 'src/app/domain/service/orientaciones-no-programadas/orden-no-programada-repository';
import { BeneficiarioRepository } from 'src/app/domain/service/beneficiario/beneficiario-repository';
import { AseguradoraRepository } from 'src/app/domain/service/aseguradora/aseguradora-repository';
import { MunicipioRepository } from 'src/app/domain/service/municipio/municipio-repository';
import {
  DEFAULT_ROWS_PER_PAGE,
  PAGE_SIZE_OPTIONS
} from 'src/app/common/constants-ejb';
import { environment } from 'src/environments/environment';
import {
  FiltrosOrdenNoProgramada,
  OrdenServicioDetalle,
  OrdenNoProgramadaPage
} from 'src/app/domain/model/orientaciones-no-programadas/orden-servicio-detalle';
import {
  CumplimientoRequest,
  CumplimientoResponse,
  DatosActaRequest,
  ProgramacionPendiente,
  HistorialCumplimiento
} from 'src/app/domain/model/cumplimiento/cumplimiento';
import { abrirAlertaTemprana } from 'src/app/common/alerta-temprana.utils';
import { avisarPostPersistencia } from 'src/app/common/aviso-post-persistencia';
import { orientacionesNoProgramadasPreset } from 'src/app/presentation/shared/table-standardization/table-standard-presets';
import { BusquedaPaginadorComponent } from 'src/app/presentation/shared/busquedas/busqueda-paginador.component';

/**
 * Componente: BusquedaOrdenesComponent
 *
 * Formulario de búsqueda de orientaciones no programadas con tabla de resultados paginada.
 *
 * Replica exactamente el legacy GWT:
 * - FilterOrdenesNoProgViewImpl.java  -> formulario de filtros
 * - FilterOrdenesNoProgActivity.java  -> lógica de búsqueda y validaciones
 *
 * Validaciones (del legacy):
 * 1. Al menos un filtro debe estar diligenciado
 * 2. Fechas en par: si se ingresa una, la otra es obligatoria
 *
 * Filtros fijos enviados al backend (hardcoded del legacy):
 * - snocautomatica = "S"
 * - snriesgos_program = "N"
 * - snterminada = "N"
 *
 * @author Sura - Migración GWT a Angular
 */
@Component({
  selector: 'app-busqueda-ordenes',
  standalone: true,
  imports: [
    GestionarContactosInformeDialogComponent,
    CommonModule,
    FormsModule,
    CardModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    RadioButtonModule,
    TableModule,
    DatePickerModule,
    ToastModule,
    MessagesModule,
    TooltipModule,
    ProgressSpinnerModule,
    DialogModule,
    BusquedaPaginadorComponent,
    BusquedaAsesorDialogComponent,
    BusquedaClienteDialogComponent,
    BusquedaTareaDialogComponent,
    BusquedaUnidadAdministrativaDialogComponent,
    BusquedaCentroTrabajoDialogComponent,
    BusquedaAseguradoraDialogComponent,
    FormularioCumplimientoComponent,
    HistorialCumplimientosDialogComponent
  ],
  styleUrls: ['../shared/styles/grid-table.styles.scss'],
  template: `
    <div class="p-3 sm:p-4 lg:p-6 max-w-7xl mx-auto overflow-x-hidden">
      <p-toast />
      <!-- Legacy: gestión de contactos del informe tras guardar un informe Final -->
      <app-gestionar-contactos-informe-dialog #contactosInformeDialog />

      <!-- Breadcrumb -->
      <div
        class="text-sm text-gray-600 dark:text-gray-400 mb-2 flex items-center gap-2"
      >
        <span>Cumplimientos</span>
        <span class="text-gray-400">?</span>
        <span class="font-medium text-gray-800 dark:text-gray-200"
          >Consultar Orientaciones No Programadas</span
        >
      </div>

      <!-- Header -->
      <div class="mb-4">
        <h1 class="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-1">
          Orientaciones No Programadas
        </h1>
        <p class="text-gray-600 dark:text-gray-400 text-sm">
          Búsqueda de orientaciones de servicio no programadas
        </p>
      </div>

      <!-- Formulario de Filtros -->
      <p-card styleClass="mb-4">
        <ng-template pTemplate="header">
          <div class="px-4 pt-4 font-semibold text-gray-700 dark:text-gray-200">
            Filtros de Búsqueda
          </div>
        </ng-template>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <!-- Aseguradora -->
          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Aseguradora</label
            >
            <div class="flex gap-1 min-w-0">
              <input
                pInputText
                [value]="filtros.dsAseguradora || ''"
                class="flex-1 min-w-0"
                placeholder="Seleccione una aseguradora..."
                readonly
              />
              <p-button
                icon="pi pi-search"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="min-w-[44px] min-h-[44px]"
                pTooltip="Buscar aseguradora"
                (onClick)="dialogBuscarAseguradoraVisible = true"
              />
              @if (filtros.nmconsecutivoCliente) {
                <p-button
                  icon="pi pi-times"
                  severity="danger"
                  [text]="true"
                  size="small"
                  styleClass="min-w-[44px] min-h-[44px]"
                  pTooltip="Limpiar aseguradora"
                  (onClick)="limpiarAseguradora()"
                />
              }
            </div>
          </div>

          <!-- Nro. Orden -->
          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Orden de Servicio</label
            >
            <input
              pInputText
              [(ngModel)]="filtros.nmconsecutivoManualOrden"
              (input)="sanitizarOrdenManual()"
              class="w-full"
              maxlength="50"
              placeholder="Orientación"
              (keyup.enter)="buscar()"
            />
          </div>

          <!-- Consultor -->
          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Consultor</label
            >
            <div class="flex gap-1 min-w-0">
              <input
                pInputText
                [value]="
                  filtros.nmconsecutivoAsesor
                    ? asesorLabel() ||
                      'Consultor ' + filtros.nmconsecutivoAsesor
                    : ''
                "
                class="flex-1 min-w-0"
                placeholder="Seleccione un consultor..."
                readonly
                (click)="dialogBuscarAsesorVisible = true"
              />
              <p-button
                icon="pi pi-search"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="min-w-[44px] min-h-[44px]"
                pTooltip="Buscar consultor"
                (onClick)="dialogBuscarAsesorVisible = true"
              />
              @if (filtros.nmconsecutivoAsesor) {
                <p-button
                  icon="pi pi-times"
                  severity="danger"
                  [text]="true"
                  size="small"
                  styleClass="min-w-[44px] min-h-[44px]"
                  pTooltip="Limpiar consultor"
                  (onClick)="limpiarAsesor()"
                />
              }
            </div>
          </div>

          <!-- Beneficiario / Cliente -->
          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Beneficiario / Cliente</label
            >
            <div class="flex gap-1 min-w-0">
              <input
                pInputText
                [value]="filtros.dsBeneficiarioCliente || ''"
                class="flex-1 min-w-0"
                placeholder="Seleccione un beneficiario/cliente..."
                readonly
              />
              <p-button
                icon="pi pi-search"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="min-w-[44px] min-h-[44px]"
                pTooltip="Buscar beneficiario/cliente"
                (onClick)="dialogBuscarClienteVisible = true"
              />
              @if (filtros.dsBeneficiarioCliente) {
                <p-button
                  icon="pi pi-times"
                  severity="danger"
                  [text]="true"
                  size="small"
                  styleClass="min-w-[44px] min-h-[44px]"
                  pTooltip="Limpiar beneficiario/cliente"
                  (onClick)="limpiarBeneficiarioCliente()"
                />
              }
            </div>
          </div>

          <!-- Oficina -->
          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Oficina</label
            >
            <p-dropdown
              [(ngModel)]="filtros.nmconsecutivoOficina"
              [options]="oficinas()"
              optionLabel="dsoficina"
              optionValue="nmconsecutivo"
              placeholder="Todas las oficinas"
              [showClear]="true"
              [filter]="true"
              filterBy="dsoficina"
              appendTo="body"
              class="w-full"
              styleClass="w-full"
              [loading]="cargandoOficinas()"
            />
          </div>

          <!-- Unidad Administrativa -->
          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Unidad Administrativa</label
            >
            <div class="flex gap-1 min-w-0">
              <input
                pInputText
                [value]="filtros.dsUen || ''"
                class="flex-1 min-w-0"
                placeholder="Seleccione una UEN..."
                readonly
              />
              <p-button
                icon="pi pi-search"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="min-w-[44px] min-h-[44px]"
                pTooltip="Buscar unidad administrativa"
                (onClick)="dialogBuscarUenVisible = true"
              />
              @if (filtros.cdunidadAdministrativa) {
                <p-button
                  icon="pi pi-times"
                  severity="danger"
                  [text]="true"
                  size="small"
                  styleClass="min-w-[44px] min-h-[44px]"
                  pTooltip="Limpiar unidad administrativa"
                  (onClick)="limpiarUen()"
                />
              }
            </div>
          </div>

          <!-- Tarea -->
          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Tarea</label
            >
            <div class="flex gap-1 min-w-0">
              <input
                pInputText
                [value]="filtros.dsTarea || ''"
                class="flex-1 min-w-0"
                placeholder="Seleccione una tarea..."
                readonly
              />
              <p-button
                icon="pi pi-search"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="min-w-[44px] min-h-[44px]"
                pTooltip="Buscar tarea"
                (onClick)="dialogBuscarTareaVisible = true"
              />
              @if (filtros.nmconsecHomologacionServicio) {
                <p-button
                  icon="pi pi-times"
                  severity="danger"
                  [text]="true"
                  size="small"
                  styleClass="min-w-[44px] min-h-[44px]"
                  pTooltip="Limpiar tarea"
                  (onClick)="limpiarTarea()"
                />
              }
            </div>
          </div>

          <!-- Centro de Trabajo -->
          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Centro de Trabajo</label
            >
            <div class="flex gap-1 min-w-0">
              <input
                pInputText
                [value]="filtros.dsCentroTrabajo || ''"
                class="flex-1 min-w-0"
                placeholder="Seleccione centro de trabajo..."
                readonly
              />
              <p-button
                icon="pi pi-search"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="min-w-[44px] min-h-[44px]"
                pTooltip="Buscar centro de trabajo"
                [disabled]="!filtros.nmconsecutivoBeneficiario"
                (onClick)="dialogBuscarCtVisible = true"
              />
              @if (filtros.nmconsecBenefCt) {
                <p-button
                  icon="pi pi-times"
                  severity="danger"
                  [text]="true"
                  size="small"
                  styleClass="min-w-[44px] min-h-[44px]"
                  pTooltip="Limpiar centro de trabajo"
                  (onClick)="limpiarCentroTrabajo()"
                />
              }
            </div>
            @if (!filtros.nmconsecutivoBeneficiario) {
              <small class="text-gray-400 dark:text-gray-500 text-xs"
                >Seleccione un beneficiario primero</small
              >
            }
          </div>

          <!-- Tipo de Fecha + Fechas -->
          <div class="sm:col-span-2 lg:col-span-3">
            <div
              class="border rounded p-3 bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700"
            >
              <div
                class="font-medium text-sm text-gray-700 dark:text-gray-200 mb-3"
              >
                Rango de Fechas
              </div>
              <div class="flex flex-wrap items-center gap-4">
                <!-- Tipo de fecha -->
                <div class="flex items-center gap-4">
                  <label class="text-sm text-gray-700 dark:text-gray-300 mr-2"
                    >Tipo:</label
                  >
                  <div class="flex items-center gap-1">
                    <p-radioButton
                      name="tipoFecha"
                      value="ENTREGA"
                      [(ngModel)]="filtros.tipoFecha"
                      inputId="tipo-entrega"
                    />
                    <label
                      for="tipo-entrega"
                      class="text-sm cursor-pointer text-gray-700 dark:text-gray-300"
                      >Fecha Entrega</label
                    >
                  </div>
                  <div class="flex items-center gap-1">
                    <p-radioButton
                      name="tipoFecha"
                      value="APROBACION"
                      [(ngModel)]="filtros.tipoFecha"
                      inputId="tipo-aprobacion"
                    />
                    <label
                      for="tipo-aprobacion"
                      class="text-sm cursor-pointer text-gray-700 dark:text-gray-300"
                      >Fecha Aprobación</label
                    >
                  </div>
                </div>
                <!-- Fecha Inicial -->
                <div class="flex items-center gap-2">
                  <label class="text-sm text-gray-700 dark:text-gray-300"
                    >Desde:</label
                  >
                  <p-datepicker
                    [(ngModel)]="fechaInicialDate"
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    placeholder="dd/mm/aaaa"
                    appendTo="body"
                    [maxDate]="fechaFinalDate || undefined"
                    (onSelect)="onFechaInicialChange($event)"
                    (onClearClick)="onFechaInicialClear()"
                  />
                </div>
                <!-- Fecha Final -->
                <div class="flex items-center gap-2">
                  <label class="text-sm text-gray-700 dark:text-gray-300"
                    >Hasta:</label
                  >
                  <p-datepicker
                    [(ngModel)]="fechaFinalDate"
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    placeholder="dd/mm/aaaa"
                    appendTo="body"
                    [minDate]="fechaInicialDate || undefined"
                    (onSelect)="onFechaFinalChange($event)"
                    (onClearClick)="onFechaFinalClear()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botones -->
        <div
          class="flex flex-wrap justify-end sm:justify-start gap-2 sm:gap-3 mt-4 w-full"
        >
          <p-button
            label="Limpiar"
            icon="pi pi-eraser"
            severity="secondary"
            (onClick)="limpiar()"
          />
          <p-button
            label="Buscar"
            icon="pi pi-search"
            [loading]="loading()"
            [disabled]="!puedesBuscar"
            (onClick)="buscar()"
          />
        </div>

        <!-- Mensaje de validación -->
        @if (mensajeValidacion()) {
          <div class="mt-3">
            <p-messages
              [value]="[{ severity: 'warn', summary: mensajeValidacion()! }]"
              [closable]="false"
            />
          </div>
        }
      </p-card>

      <!-- Tabla de Resultados -->
      @if (mostrarResultados()) {
        <p-card>
          <ng-template pTemplate="header">
            <div
              class="px-4 pt-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2"
            >
              <span class="font-semibold text-gray-700 dark:text-gray-200"
                >Resultados</span
              >
              @if (totalRegistros() > 0) {
                <span class="text-sm text-gray-600 dark:text-gray-400">
                  Registros del {{ registroInicio() }} hasta el
                  {{ registroFin() }} de {{ totalRegistros() }}
                </span>
              }
            </div>
          </ng-template>

          @if (resultados().length === 0) {
            <p-messages
              [value]="[
                {
                  severity: 'warn',
                  summary:
                    'No se encontraron registros con los filtros seleccionados.'
                }
              ]"
              [closable]="false"
            />
          } @else {
            <div class="md:hidden space-y-3">
              @for (
                orden of resultados();
                track orden.nmconsecutivoManualOrden ?? $index
              ) {
                <div
                  class="border border-gray-200 dark:border-gray-700 rounded-lg p-3 bg-white dark:bg-gray-900"
                >
                  <div class="flex items-start justify-between gap-2 mb-3">
                    <div class="min-w-0">
                      <div class="text-xs text-gray-500 dark:text-gray-400">
                        Orientación
                      </div>
                      <div
                        class="font-semibold text-gray-800 dark:text-gray-100 truncate"
                        [attr.title]="
                          tituloTabla(orden.nmconsecutivoManualOrden)
                        "
                      >
                        {{ textoTabla(orden.nmconsecutivoManualOrden) }}
                      </div>
                    </div>
                    <p-button
                      icon="pi pi-info-circle"
                      severity="secondary"
                      [outlined]="true"
                      size="small"
                      styleClass="min-w-[44px] min-h-[44px] shrink-0"
                      pTooltip="Información empresa"
                      (onClick)="verInfoEmpresa(orden)"
                    />
                  </div>

                  <div
                    class="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm mb-3"
                  >
                    <div>
                      <span class="text-gray-500 dark:text-gray-400"
                        >Cliente:</span
                      >
                      <span class="text-gray-800 dark:text-gray-200">{{
                        textoTabla(orden.nombreBeneficiario)
                      }}</span>
                    </div>
                    <div>
                      <span class="text-gray-500 dark:text-gray-400"
                        >Centro de Trabajo:</span
                      >
                      <span class="text-gray-800 dark:text-gray-200">{{
                        textoTabla(orden.dsCentroTrabajo)
                      }}</span>
                    </div>
                    <div>
                      <span class="text-gray-500 dark:text-gray-400"
                        >Producto:</span
                      >
                      <span class="text-gray-800 dark:text-gray-200">{{
                        textoTabla(orden.dsProducto)
                      }}</span>
                    </div>
                    <div>
                      <span class="text-gray-500 dark:text-gray-400"
                        >Tarea:</span
                      >
                      <span class="text-gray-800 dark:text-gray-200">{{
                        textoTabla(orden.dsServicio)
                      }}</span>
                    </div>
                    <div>
                      <span class="text-gray-500 dark:text-gray-400"
                        >Clasificación:</span
                      >
                      <span class="text-gray-800 dark:text-gray-200">{{
                        textoTabla(orden.dsAbreviaturaClasificacion)
                      }}</span>
                    </div>
                    <div>
                      <span class="text-gray-500 dark:text-gray-400"
                        >Cant. Pedida:</span
                      >
                      <span class="text-gray-800 dark:text-gray-200">{{
                        textoTabla(orden.nmcantidadPedida)
                      }}</span>
                    </div>
                    <div>
                      <span class="text-gray-500 dark:text-gray-400"
                        >Saldo Ejecutar:</span
                      >
                      <span class="text-gray-800 dark:text-gray-200">{{
                        textoTabla(orden.saldoEjecutar)
                      }}</span>
                    </div>
                    <div>
                      <span class="text-gray-500 dark:text-gray-400"
                        >F. Entrega Ini.:</span
                      >
                      <span class="text-gray-800 dark:text-gray-200">{{
                        textoTabla(formatFecha(orden.feEntregaInicial))
                      }}</span>
                    </div>
                    <div>
                      <span class="text-gray-500 dark:text-gray-400"
                        >F. Entrega Fin.:</span
                      >
                      <span class="text-gray-800 dark:text-gray-200">{{
                        textoTabla(formatFecha(orden.feEntregaFinal))
                      }}</span>
                    </div>
                  </div>

                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <p-button
                      label="Detalle"
                      icon="pi pi-list"
                      severity="secondary"
                      [outlined]="true"
                      size="small"
                      styleClass="w-full min-h-[44px]"
                      (onClick)="verDetalleTarea(orden)"
                    />
                    <p-button
                      label="Seleccionar"
                      icon="pi pi-calendar-plus"
                      size="small"
                      styleClass="w-full min-h-[44px]"
                      (onClick)="seleccionar(orden)"
                    />
                  </div>
                </div>
              }
            </div>

            <div class="hidden md:block">
              <div
                role="region"
                [attr.aria-label]="ordenesTableConfig().a11y.tableAriaLabel"
                class="sr-only"
              ></div>
              <p-table
                [value]="resultados()"
                [paginator]="false"
                [rows]="pageSize()"
                [loading]="loading()"
                [scrollable]="true"
                [responsiveLayout]="'scroll'"
                [resizableColumns]="
                  ordenesTableConfig().style.resizableColumns !== false
                "
                columnResizeMode="expand"
                [styleClass]="ordenesTableStyleClass()"
                [tableStyle]="{
                  'min-width':
                    ordenesTableConfig().responsive.minWidth || '72rem'
                }"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th pResizableColumn>
                      <span class="grid-header-text" title="Orientación"
                        >Orientación</span
                      >
                    </th>
                    <th class="text-center" pResizableColumn>Inf.</th>
                    <th pResizableColumn>
                      <span class="grid-header-text" title="Cliente"
                        >Cliente</span
                      >
                    </th>
                    <th pResizableColumn>
                      <span class="grid-header-text" title="Centro de Trabajo"
                        >Centro de Trabajo</span
                      >
                    </th>
                    <th pResizableColumn>
                      <span class="grid-header-text" title="Producto"
                        >Producto</span
                      >
                    </th>
                    <th pResizableColumn>
                      <span class="grid-header-text" title="Tarea">Tarea</span>
                    </th>
                    <th pResizableColumn>
                      <span class="grid-header-text" title="Clasificación"
                        >Clasificación</span
                      >
                    </th>
                    <th class="text-right" pResizableColumn>
                      <span class="grid-header-text" title="Cant. Pedida"
                        >Cant. Pedida</span
                      >
                    </th>
                    <th class="text-right" pResizableColumn>
                      <span class="grid-header-text" title="Saldo Ejecutar"
                        >Saldo Ejecutar</span
                      >
                    </th>
                    <th pResizableColumn>
                      <span class="grid-header-text" title="F. Entrega Ini."
                        >F. Entrega Ini.</span
                      >
                    </th>
                    <th pResizableColumn>
                      <span class="grid-header-text" title="F. Entrega Fin."
                        >F. Entrega Fin.</span
                      >
                    </th>
                    <th class="text-center">Detalle Tarea</th>
                    <th class="text-center">Seleccionar</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-orden>
                  <tr>
                    <td>
                      <span
                        class="grid-cell-text"
                        [attr.title]="
                          tituloTabla(orden.nmconsecutivoManualOrden)
                        "
                        >{{ textoTabla(orden.nmconsecutivoManualOrden) }}</span
                      >
                    </td>
                    <td class="text-center">
                      <p-button
                        icon="pi pi-info-circle"
                        size="small"
                        styleClass="p-button-rounded p-button-text min-w-[44px] min-h-[44px]"
                        pTooltip="Información empresa"
                        (onClick)="verInfoEmpresa(orden)"
                      />
                    </td>
                    <td>
                      <span
                        class="grid-cell-text"
                        [attr.title]="tituloTabla(orden.nombreBeneficiario)"
                        >{{ textoTabla(orden.nombreBeneficiario) }}</span
                      >
                    </td>
                    <td>
                      <span
                        class="grid-cell-text"
                        [attr.title]="tituloTabla(orden.dsCentroTrabajo)"
                        >{{ textoTabla(orden.dsCentroTrabajo) }}</span
                      >
                    </td>
                    <td>
                      <span
                        class="grid-cell-text"
                        [attr.title]="tituloTabla(orden.dsProducto)"
                        >{{ textoTabla(orden.dsProducto) }}</span
                      >
                    </td>
                    <td>
                      <span
                        class="grid-cell-text"
                        [attr.title]="tituloTabla(orden.dsServicio)"
                        >{{ textoTabla(orden.dsServicio) }}</span
                      >
                    </td>
                    <td>
                      <span
                        class="grid-cell-text"
                        [attr.title]="
                          tituloTabla(orden.dsAbreviaturaClasificacion)
                        "
                        >{{
                          textoTabla(orden.dsAbreviaturaClasificacion)
                        }}</span
                      >
                    </td>
                    <td class="text-right">
                      <span
                        class="grid-cell-text"
                        [attr.title]="tituloTabla(orden.nmcantidadPedida)"
                        >{{ textoTabla(orden.nmcantidadPedida) }}</span
                      >
                    </td>
                    <td class="text-right">
                      <span
                        class="grid-cell-text"
                        [attr.title]="tituloTabla(orden.saldoEjecutar)"
                        >{{ textoTabla(orden.saldoEjecutar) }}</span
                      >
                    </td>
                    <td>
                      <span
                        class="grid-cell-text"
                        [attr.title]="
                          tituloTabla(formatFecha(orden.feEntregaInicial))
                        "
                        >{{
                          textoTabla(formatFecha(orden.feEntregaInicial))
                        }}</span
                      >
                    </td>
                    <td>
                      <span
                        class="grid-cell-text"
                        [attr.title]="
                          tituloTabla(formatFecha(orden.feEntregaFinal))
                        "
                        >{{
                          textoTabla(formatFecha(orden.feEntregaFinal))
                        }}</span
                      >
                    </td>
                    <td class="text-center">
                      <p-button
                        icon="pi pi-list"
                        size="small"
                        styleClass="p-button-rounded p-button-text min-w-[44px] min-h-[44px]"
                        pTooltip="Ver detalle de la tarea"
                        (onClick)="verDetalleTarea(orden)"
                      />
                    </td>
                    <td class="text-center">
                      <p-button
                        icon="pi pi-calendar-plus"
                        size="small"
                        styleClass="p-button-rounded p-button-text min-w-[44px] min-h-[44px]"
                        pTooltip="Seleccionar para cumplimiento"
                        (onClick)="seleccionar(orden)"
                      />
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="13" class="text-center text-gray-500 py-4">
                      No hay registros disponibles.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

            <!-- Paginación Manual Cursor - skill: paginacion -->
            @if (totalRegistros() > 0) {
              <app-busqueda-paginador
                [currentPage]="currentPage()"
                [totalPages]="totalPages()"
                [hasPrevious]="hasPrevious()"
                [hasNext]="hasNext()"
                [pageSizeOptions]="pageSizeOptionValues"
                [selectedPageSize]="selectedPageSize"
                (pageSizeChange)="selectedPageSize = $event; onPageSizeChange()"
                (first)="irPrimeraPagina()"
                (previous)="irPaginaAnterior()"
                (next)="irPaginaSiguiente()"
                (last)="irUltimaPagina()"
              ></app-busqueda-paginador>
            }
          }
        </p-card>
      }

      <!-- ======================================================== -->
      <!-- DIALOGOS DE BUSQUEDA                                     -->
      <!-- ======================================================== -->

      <!-- Búsqueda de Consultor -->
      @if (dialogBuscarAsesorVisible) {
        <app-asesor-search
          [titulo]="'Búsqueda de Asesor/Consultor'"
          (onSelect)="seleccionarAsesorYCerrar($event)"
          (onClose)="dialogBuscarAsesorVisible = false"
        />
      }

      <!-- Búsqueda de Beneficiario / Cliente -->
      @if (dialogBuscarClienteVisible) {
        <app-busqueda-cliente-dialog
          [titulo]="'Buscar Beneficiario / Cliente'"
          (onSelect)="onClienteSeleccionado($event)"
          (onClose)="dialogBuscarClienteVisible = false"
        />
      }

      <!-- Búsqueda de Unidad Administrativa — Legacy: TPSC_UNS_ADMINISTRATIVAS -->
      @if (dialogBuscarUenVisible) {
        <app-busqueda-unidad-administrativa-dialog
          [nmconsecutivoCliente]="filtros.nmconsecutivoCliente"
          (unidadAdministrativaSelected)="onUenSeleccionada($event)"
          (dialogClosed)="dialogBuscarUenVisible = false"
        />
      }

      <!-- Búsqueda de Tarea -->
      @if (dialogBuscarTareaVisible) {
        <app-busqueda-tarea-dialog
          [titulo]="'Búsqueda de Tarea'"
          (onSelect)="onTareaSeleccionada($event)"
          (onClose)="dialogBuscarTareaVisible = false"
        />
      }

      <!-- Búsqueda de Centro de Trabajo -->
      @if (dialogBuscarCtVisible) {
        <app-busqueda-centro-trabajo-dialog
          [titulo]="'Búsqueda de Centro de Trabajo'"
          [nmconsecutivoBeneficiario]="
            filtros.nmconsecutivoBeneficiario ?? null
          "
          (onSelect)="onCentroTrabajoSeleccionado($event)"
          (onClose)="dialogBuscarCtVisible = false"
        />
      }

      <!-- Búsqueda de Aseguradora -->
      @if (dialogBuscarAseguradoraVisible) {
        <app-busqueda-aseguradora-dialog
          (aseguradoraSelected)="onAseguradoraSeleccionada($event)"
          (dialogClosed)="dialogBuscarAseguradoraVisible = false"
        />
      }

      <!-- Modal Detalle Tarea -->
      <!-- Legacy: DetalleTareaActivity.showModalDetalle() -->
      <p-dialog
        header="Detalle de la Tarea"
        [(visible)]="detalleTareaVisible"
        [modal]="true"
        [style]="{ width: '92vw', maxWidth: '48rem' }"
        [contentStyle]="{ 'max-height': '80vh', 'overflow-y': 'auto' }"
        [breakpoints]="{ '1024px': '88vw', '768px': '92vw', '640px': '96vw' }"
        [closable]="true"
      >
        @if (ordenDetalle()) {
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div class="col-span-2">
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Requiere Informe:</span
              >
              <span class="ml-2 text-gray-700 dark:text-gray-200">{{
                ordenDetalle()!.snrequiereInforme || '-'
              }}</span>
            </div>
            <div class="col-span-2">
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Profesional Prevención:</span
              >
              <span class="ml-2 text-gray-700 dark:text-gray-200">{{
                ordenDetalle()!.dsNombProfesionalPrevencion || '-'
              }}</span>
            </div>
            <div class="col-span-2">
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Consultor Sugerido:</span
              >
              <span class="ml-2 text-gray-700 dark:text-gray-200">{{
                ordenDetalle()!.dsNombreAsesorSugerido || '-'
              }}</span>
            </div>
            <div class="col-span-2">
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Nombre Contacto:</span
              >
              <span class="ml-2 text-gray-700 dark:text-gray-200">{{
                ordenDetalle()!.dsNombrContactoBeneficiario || '-'
              }}</span>
            </div>
            <div class="col-span-2">
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Teléfono Contacto:</span
              >
              <span class="ml-2 text-gray-700 dark:text-gray-200">{{
                ordenDetalle()!.dsNombreContactoBeneficiario || '-'
              }}</span>
            </div>
            <div class="col-span-2">
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Dirección:</span
              >
              <span class="ml-2 text-gray-700 dark:text-gray-200">{{
                ordenDetalle()!.dsdireccion || '-'
              }}</span>
            </div>
            <div>
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Municipio Entrega:</span
              >
              <span class="ml-2 text-gray-700 dark:text-gray-200">{{
                ordenDetalle()!.dsMunicipioEntrega || '-'
              }}</span>
            </div>
            <div>
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Barrio:</span
              >
              <span class="ml-2 text-gray-700 dark:text-gray-200">{{
                ordenDetalle()!.dsbarrioPpal || '-'
              }}</span>
            </div>
            <div>
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Localidad:</span
              >
              <span class="ml-2 text-gray-700 dark:text-gray-200">{{
                ordenDetalle()!.dslocalidadPpal || '-'
              }}</span>
            </div>
            <div class="col-span-2">
              <span class="font-semibold text-gray-600 dark:text-gray-300"
                >Observaciones:</span
              >
              <p
                class="mt-1 text-gray-700 dark:text-gray-200 bg-gray-50 dark:bg-gray-700/50 rounded p-2"
              >
                {{ ordenDetalle()!.dsobservaciones || '-' }}
              </p>
            </div>
          </div>
        }
      </p-dialog>

      <app-formulario-cumplimiento
        [visible]="dialogCumplimientoVisible()"
        [programacion]="programacionSeleccionada()"
        [saldoActual]="saldoActual()"
        [loading]="loadingGuardarCumplimiento()"
        [flujo]="'NO_PROGRAMADA'"
        [esTipoCampo]="false"
        [esTipoInforme]="false"
        [requiereJustificacion]="false"
        [justificaciones]="justificaciones"
        [tiposCita]="tiposCitaNoProgramada()"
        [onObtenerMunicipio]="obtenerMunicipioPorCodigo"
        [actaError]="actaError()"
        [mostrarBotonReintentar]="mostrarBotonReintentar()"
        [actaGenerando]="actaGenerando()"
        [mostrarBotonDescargarActa]="mostrarBotonDescargarActa()"
        [descargandoActa]="descargandoActaAsociada()"
        (visibleChange)="dialogCumplimientoVisible.set($event)"
        (guardar)="guardarCumplimientoNoProgramado($event)"
        (cancelar)="cerrarFormularioCumplimiento()"
        (reportarAlertaTemprana)="reportarAlertaTemprana()"
        (verHistorial)="onVerHistorialCumplimientos()"
        (reintentar)="onReintentarActa($event)"
        (descargarActa)="onDescargarActaAsociada()"
      >
      </app-formulario-cumplimiento>

      <app-historial-cumplimientos-dialog
        [visible]="historialCumplimientosVisible()"
        [cumplimientos]="historialCumplimientos()"
        (cerrar)="historialCumplimientosVisible.set(false)"
        (recargarHistorial)="onVerHistorialCumplimientos()"
      >
      </app-historial-cumplimientos-dialog>
    </div>
  `
})
export class BusquedaOrdenesComponent implements OnInit {
  sanitizeText = sanitizeText;
  private readonly oficinaRepo = inject(OficinaRepository);
  private readonly agendaRepo = inject(AgendaRepository);
  private readonly cumplimientoRepo = inject(CumplimientoRepository);
  private readonly ordenRepo = inject(OrdenNoProgramadaRepository);
  private readonly beneficiarioRepo = inject(BeneficiarioRepository);
  private readonly aseguradoraRepo = inject(AseguradoraRepository);
  private readonly municipioRepo = inject(MunicipioRepository);
  private readonly personaRepo = inject(PersonaRepository);
  private readonly messageService = inject(MessageService);
  private readonly cdr = inject(ChangeDetectorRef);

  // === ViewChild para llamar setItems() en los diálogos ===
  @ViewChild('contactosInformeDialog') contactosInformeDialog?: GestionarContactosInformeDialogComponent;

  // === Estado reactivo ===
  oficinas = signal<Oficina[]>([]);
  cargandoOficinas = signal(false);
  loading = signal(false);
  resultados = signal<OrdenServicioDetalle[]>([]);
  totalRegistros = signal(0);
  mostrarResultados = signal(false);
  mensajeValidacion = signal<string | null>(null);

  // Modal Detalle Tarea -> Legacy: DetalleTareaActivity
  detalleTareaVisible = false;
  ordenDetalle = signal<OrdenServicioDetalle | null>(null);

  // Reutilización de formulario de cumplimiento
  dialogCumplimientoVisible = signal(false);
  loadingGuardarCumplimiento = signal(false);
  programacionSeleccionada = signal<ProgramacionPendiente | null>(null);
  saldoActual = signal(0);
  tiposCitaNoProgramada = signal<Array<{ label: string; value: number }>>([]);
  /** DNI del asesor sugerido de la orden seleccionada (viene del listado) */
  dniAsesorOrden = signal<string | null>(null);
  nmconsecutivoAsesorOrden = signal<number | null>(null);

  // === Estado de acta 360 (HU1132419) ===
  /** Mensaje de error si la generación del acta falló */
  actaError = signal<string | null>(null);
  /** Indica si se está reintentando la generación del acta */
  actaGenerando = signal(false);
  /** Muestra el botón "Generar Nuevamente" cuando el acta falló */
  mostrarBotonReintentar = signal(false);
  /** Muestra el botón de descarga del acta tras asociación exitosa. */
  mostrarBotonDescargarActa = signal(false);
  /** Loading del botón de descarga del acta asociada. */
  descargandoActaAsociada = signal(false);
  /** Consecutivo del cumplimiento guardado (para el reintento) */
  private nmconsecutivoCumplimientoGuardado: number | null = null;
  /** Consecutivo del cumplimiento disponible para descarga de acta. */
  private nmconsecutivoCumplimientoDescargable: number | null = null;
  /** Consecutivo de programación asociado para consultar historial en NO_PROGRAMADA. */
  private nmconsecutivoProgramacionActual: number | null = null;
  /** Datos del acta del último guardado (para el reintento) */
  private ultimaDatosActa: CumplimientoRequest['datosActa'] | null = null;

  historialCumplimientosVisible = signal(false);
  historialCumplimientos = signal<HistorialCumplimiento[]>([]);

  readonly justificaciones = [
    { label: 'Reprogramación por cliente', value: 1 },
    { label: 'Reprogramación por consultor', value: 2 },
    { label: 'Incapacidad del consultor', value: 3 },
    { label: 'Fuerza mayor', value: 4 },
    { label: 'Otro', value: 99 }
  ];

  // === Estado buscador asesor ===
  asesorSeleccionado = signal<Persona | null>(null);
  asesores = signal<Persona[]>([]);
  loadingAsesorBusqueda = signal(false);
  asesorLabel = () =>
    this.asesorSeleccionado()
      ? getNombreCompleto(this.asesorSeleccionado()!)
      : '';

  // === Filtros del formulario ===
  // Legacy: initializeFields() -> rbgFechas.getRadioButton(FILTRO_FECHA_APROBACION).setValue(true)
  filtros: FiltrosOrdenNoProgramada = {
    tipoFecha: 'APROBACION'
  };

  // Auxiliares de fecha (p-calendar usa Date, no string)
  fechaInicialDate: Date | null = null;
  fechaFinalDate: Date | null = null;

  // Control de diálogos
  dialogBuscarAsesorVisible = false;
  dialogBuscarClienteVisible = false;
  dialogBuscarUenVisible = false;
  dialogBuscarTareaVisible = false;
  dialogBuscarCtVisible = false;
  dialogBuscarAseguradoraVisible = false;

  // Paginación Cursor/Keyset -> skill: paginacion
  currentPage = signal(1); // 1-based (display)
  pageSize = signal(DEFAULT_ROWS_PER_PAGE);
  selectedPageSize = DEFAULT_ROWS_PER_PAGE;
  pageSizeOptions = PAGE_SIZE_OPTIONS.map((v) => ({
    label: String(v),
    value: v
  }));
  pageSizeOptionValues = PAGE_SIZE_OPTIONS;

  readonly ordenesTableConfig = computed(() =>
    orientacionesNoProgramadasPreset.createConfig({
      data: this.resultados() as unknown as Record<string, unknown>[],
      style: {
        tableClassName: 'tabla-orientaciones-no-programadas',
        striped: false,
        gridlines: false,
        resizableColumns: true,
        rowHover: false
      },
      pagination: {
        enabled: false,
        mode: 'server',
        pageSize: this.pageSize(),
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        currentPageReportTemplate:
          'Registros del {first} hasta el {last} de {totalRecords}'
      },
      state: {
        loading: this.loading(),
        emptyMessage: 'No hay registros disponibles.'
      },
      responsive: {
        mode: 'hybrid',
        minWidth: '72rem',
        scrollHeight: 'auto',
        cardBreakpointPx: 768
      },
      a11y: {
        tableAriaLabel: 'Tabla de orientaciones no programadas',
        announceSelection: false,
        announcePageChanges: true,
        focusFirstActionOnRowSelect: false
      }
    })
  );

  readonly ordenesTableStyleClass = computed(() => {
    const config = this.ordenesTableConfig();
    const classes = ['p-datatable-sm', config.style.tableClassName];
    if (config.style.gridlines !== false) {
      classes.push('p-datatable-gridlines');
    }
    if (config.style.striped !== false) {
      classes.push('p-datatable-striped');
    }
    return classes.join(' ');
  });

  // Computados para UX (igual que otros buscadores)
  totalPages = computed(() => {
    const total = this.totalRegistros();
    const size = this.pageSize();
    return total > 0 ? Math.ceil(total / size) : 0;
  });

  registroInicio = computed(() => {
    if (this.totalRegistros() === 0) return 0;
    return (this.currentPage() - 1) * this.pageSize() + 1;
  });

  registroFin = computed(() => {
    if (this.totalRegistros() === 0) return 0;
    return Math.min(
      this.registroInicio() + this.resultados().length - 1,
      this.totalRegistros()
    );
  });

  // Cursores del backend
  nextCursor = signal<string | null>(null);
  previousCursor = signal<string | null>(null);

  // Flags de navegación: los fija la RESPUESTA del backend (frontend-girop 17.7).
  hasPrevious = signal(false);
  hasNext = signal(false);

  // === Computed ===
  /**
  * Verifica que al menos un filtro esté diligenciado.
  * Legacy: FilterOrdenesNoProgViewImpl - validación de formulario
   */
  get puedesBuscar(): boolean {
    const f = this.filtros;
    return !!(
      f.nmconsecutivoManualOrden?.trim() ||
      f.nmconsecutivoAsesor ||
      f.cdpersonaCliente ||
      f.nmconsecutivoBeneficiario ||
      f.nmconsecutivoOficina ||
      f.cdunidadAdministrativa ||
      f.nmconsecHomologacionServicio ||
      f.nmconsecBenefCt ||
      f.fechaInicial ||
      f.nmconsecutivoCliente
    );
  }

  ngOnInit(): void {
    this.cargarOficinas();
    this.cargarAseguradoraDefault();
    this.initBuscadores();
  }

  private initBuscadores(): void {
    this.asesorSeleccionado.set(null);
    this.asesores.set([]);
  }

  private async cargarAseguradoraDefault(): Promise<void> {
    try {
      const aseguradora =
        await this.aseguradoraRepo.obtenerAseguradoraDefault();
      if (!aseguradora) return;
      this.filtros = {
        ...this.filtros,
        nmconsecutivoCliente: aseguradora.nmconsecutivo,
        dsAseguradora:
          aseguradora.nombreComercial || aseguradora.primerNombre || ''
      };
      this.cdr.detectChanges();
    } catch {
      // Si falla, continuar sin aseguradora por defecto
    }
  }

  private async cargarOficinas(): Promise<void> {
    this.cargandoOficinas.set(true);
    try {
      const lista = await this.oficinaRepo.obtenerOficinas();
      this.oficinas.set(lista);
    } catch {
      this.messageService.add({
        severity: 'warn',
        summary: 'No se pudieron cargar las oficinas',
        life: 3000
      });
    } finally {
      this.cargandoOficinas.set(false);
    }
  }

  /**
   * Sanitización XSS del número manual de orden, único texto libre del filtro
   * (seguridad-girop §3). No altera los caracteres alfanuméricos del código;
   * al teclear conserva espacios y antes de buscar también los recorta.
   */
  sanitizarOrdenManual(recortar = false): void {
    const valor = this.filtros.nmconsecutivoManualOrden;
    if (valor === undefined || valor === null) return;
    this.filtros.nmconsecutivoManualOrden = recortar
      ? sanitizeText(valor)
      : sanitizeTextPreserveSpaces(valor);
  }

  async buscar(
    cursor: string | null = null,
    direction: 'NEXT' | 'PREVIOUS' = 'NEXT',
    pagina = 1
  ): Promise<void> {
    this.mensajeValidacion.set(null);
    this.sanitizarOrdenManual(true);

    // Validación: al menos un filtro diligenciado
    if (!this.puedesBuscar) {
      this.mensajeValidacion.set(
        'Debe diligenciar al menos un filtro para buscar.'
      );
      return;
    }

    // Validación: fechas en par
    const tieneFechaInicial = !!this.filtros.fechaInicial;
    const tieneFechaFinal = !!this.filtros.fechaFinal;
    if (tieneFechaInicial !== tieneFechaFinal) {
      this.mensajeValidacion.set(
        'Debe diligenciar tanto la fecha inicial como la final, o dejar ambas vacías.'
      );
      return;
    }

    this.loading.set(true);

    try {
      const resultado: OrdenNoProgramadaPage =
        await this.ordenRepo.buscarOrdenes(
          this.filtros,
          cursor,
          this.pageSize(),
          direction
        );
      this.resultados.set(resultado.content);
      this.totalRegistros.set(resultado.totalElements ?? 0);
      this.nextCursor.set(resultado.nextCursor ?? null);
      this.previousCursor.set(resultado.previousCursor ?? null);
      this.hasNext.set(!!resultado.hasNext);
      this.hasPrevious.set(!!resultado.hasPrevious);
      // La página solo cambia tras la respuesta exitosa.
      this.currentPage.set(pagina);
      this.mostrarResultados.set(true);
    } catch {
      this.messageService.add({
        severity: 'error',
        summary: 'Error al buscar órdenes',
        detail:
          'Ocurrió un error al consultar las órdenes. Intente nuevamente.',
        life: 5000
      });
    } finally {
      this.loading.set(false);
    }
  }

  async irPrimeraPagina(): Promise<void> {
    if (this.loading()) return;
    await this.buscar(null, 'NEXT', 1);
  }

  async irPaginaAnterior(): Promise<void> {
    if (this.loading() || !this.hasPrevious()) return;
    await this.buscar(
      this.previousCursor(),
      'PREVIOUS',
      Math.max(1, this.currentPage() - 1)
    );
  }

  async irPaginaSiguiente(): Promise<void> {
    if (this.loading() || !this.hasNext()) return;
    await this.buscar(this.nextCursor(), 'NEXT', this.currentPage() + 1);
  }

  async irUltimaPagina(): Promise<void> {
    if (this.loading()) return;
    // Este endpoint aún no soporta LAST: PREVIOUS sin cursor devuelve la última página.
    await this.buscar(
      null,
      'PREVIOUS',
      Math.max(1, this.totalPages())
    );
  }

  async onPageSizeChange(): Promise<void> {
    this.pageSize.set(this.selectedPageSize);
    await this.buscar(null, 'NEXT', 1);
  }

  limpiar(): void {
    // Legacy: reset() -> initBuscadores() + limpieza de campos
    this.filtros = { tipoFecha: 'APROBACION' };
    this.fechaInicialDate = null;
    this.fechaFinalDate = null;
    this.asesorSeleccionado.set(null);
    this.asesores.set([]);
    this.cargarAseguradoraDefault();
    this.resultados.set([]);
    this.totalRegistros.set(0);
    this.nextCursor.set(null);
    this.previousCursor.set(null);
    this.hasNext.set(false);
    this.hasPrevious.set(false);
    this.mostrarResultados.set(false);
    this.mensajeValidacion.set(null);
    this.currentPage.set(1);
  }

  async seleccionar(orden: OrdenServicioDetalle): Promise<void> {
    const idOrden = orden.nmconsecutivo ?? orden.nmconsecutivoTarea;
    if (!idOrden) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Orientación inválida',
        detail:
          'La orientación seleccionada no tiene consecutivo interno para registrar cumplimiento.',
        life: 4000
      });
      return;
    }

    await this.cargarTiposCitaNoProgramada(orden);
    this.mostrarBotonDescargarActa.set(false);
    this.nmconsecutivoCumplimientoDescargable = null;
    this.programacionSeleccionada.set(this.mapearOrdenAProgramacion(orden));
    this.nmconsecutivoProgramacionActual = null;
    this.dniAsesorOrden.set(orden.dniAsesorSugerido ?? null);
    this.nmconsecutivoAsesorOrden.set(
      orden.nmconsecutivoAsesorSugerido ?? null
    );
    this.saldoActual.set(orden.saldoEjecutar || 0);
    this.dialogCumplimientoVisible.set(true);
  }

  private async cargarTiposCitaNoProgramada(
    orden: OrdenServicioDetalle
  ): Promise<void> {
    try {
      const tipos = await this.agendaRepo.listarTiposCita(
        undefined,
        'SERVICIO'
      );

      let opciones = tipos.map((tipo) => ({
        label: tipo.dstipo,
        value: tipo.nmconsecutivo
      }));

      if ((orden.cdclasificacion || '').trim() === '3') {
        opciones = opciones.filter((op) => op.value === 17);
      }

      this.tiposCitaNoProgramada.set(opciones);
    } catch {
      this.tiposCitaNoProgramada.set([]);
      this.messageService.add({
        severity: 'warn',
        summary: 'Tipos de cita no disponibles',
        detail:
          'No fue posible cargar el catálogo de tipos de cita para la orientación.',
        life: 4000
      });
    }
  }

  cerrarFormularioCumplimiento(): void {
    this.dialogCumplimientoVisible.set(false);
    this.programacionSeleccionada.set(null);
    this.dniAsesorOrden.set(null);
    this.nmconsecutivoAsesorOrden.set(null);
    // Limpiar estado de acta
    this.actaError.set(null);
    this.actaGenerando.set(false);
    this.mostrarBotonReintentar.set(false);
    this.mostrarBotonDescargarActa.set(false);
    this.descargandoActaAsociada.set(false);
    this.nmconsecutivoCumplimientoGuardado = null;
    this.nmconsecutivoCumplimientoDescargable = null;
    this.nmconsecutivoProgramacionActual = null;
    this.ultimaDatosActa = null;
    this.historialCumplimientosVisible.set(false);
    this.historialCumplimientos.set([]);
  }

  async reportarAlertaTemprana(): Promise<void> {
    await abrirAlertaTemprana(
      this.programacionSeleccionada(),
      this.messageService
    );
  }

  /** Callback para obtener municipio por código DANE -> se pasa como [onObtenerMunicipio] al formulario */
  readonly obtenerMunicipioPorCodigo = (codigo: string) =>
    this.municipioRepo
      .getByCodigo(codigo)
      .then((m) => ({
        cdmunicipio: m.cdmunicipio,
        cdsura: m.cdsura || '',
        dsmunicipio: m.dsmunicipio || ''
      }))
      .catch(() => null);

  async guardarCumplimientoNoProgramado(
    request: CumplimientoRequest
  ): Promise<void> {
    if (this.loadingGuardarCumplimiento()) {
      return;
    }

    this.loadingGuardarCumplimiento.set(true);
    // El asesor viene de la orden seleccionada (TPSC_ORDEN_SERVICIO_DETAL.NMCONSECUTIVO_ASESOR_SUGERIDO).
    // Legacy: programacionDto.setNmconsecutivo_asesor(ordenDto.getNmconsecutivo_asesor_sugerido())
    // Se envía el NMCONSECUTIVO ya resuelto (prioritario) y el DNI como fallback, para que agenda-ms
    // no tenga que resolver el asesor por DNI (evita validar disponibilidad contra un asesor incorrecto).
    const nmconsecutivoAsesor = this.nmconsecutivoAsesorOrden();
    if (nmconsecutivoAsesor) {
      request.nmconsecutivoAsesor = nmconsecutivoAsesor;
    }
    const dniAsesor = this.dniAsesorOrden();
    if (dniAsesor) {
      request.dniAsesor = dniAsesor;
    }
    try {
      const response: CumplimientoResponse =
        await this.cumplimientoRepo.registrarCumplimiento(request);
      avisarPostPersistencia(this.messageService, response);
      // Legacy (CreateOrUpdateCumplimientoActivity.gestionarContactosInforme): informe Final →
      // gestión de contactos del informe
      const contactosInformePendiente = gestionContactosInformeSiAplica(request, response);
      if (contactosInformePendiente) {
        void this.contactosInformeDialog?.abrir(
          contactosInformePendiente.radicado,
          contactosInformePendiente.cumplimientos
        );
      }
      const nmconsecutivoProgramacion = (response as any)
        .nmconsecutivoProgramacion as number | undefined;
      if (nmconsecutivoProgramacion && nmconsecutivoProgramacion > 0) {
        this.nmconsecutivoProgramacionActual = nmconsecutivoProgramacion;
        const actual = this.programacionSeleccionada();
        if (actual && actual.nmconsecutivo !== nmconsecutivoProgramacion) {
          this.programacionSeleccionada.set({
            ...actual,
            nmconsecutivo: nmconsecutivoProgramacion
          });
        }
      }

      // HU1132419 -> Si el backend indica que aplica acta pero no la pudo generar
      // (asociarActa=true, idActa360=null), mantener el formulario abierto
      // y mostrar el botón "Generar Nuevamente" (legacy: mostrarOcultarOpciones(3, true)).
      if (response.asociarActa && response.idActa360 == null) {
        // Guardar datos para el reintento
        this.nmconsecutivoCumplimientoGuardado = response.nmconsecutivo;
        this.ultimaDatosActa = request.datosActa ?? null;
        this.mostrarBotonReintentar.set(true);
        const detalleBackend = response.actaMensajeError ?? undefined;
        const mensajeAlerta = detalleBackend?.trim()
          ? detalleBackend
          : 'El cumplimiento fue guardado, pero no se pudo generar el acta 360.';
        this.actaError.set(mensajeAlerta);
        // Toast de éxito parcial
        this.messageService.add({
          severity: 'success',
          summary: 'Cumplimiento registrado',
          detail:
            'La orientación fue registrada. Puede reintentar la generación del acta.',
          life: 5000
        });
        this.messageService.add({
          severity: 'warn',
          summary: 'Acta pendiente',
          detail: mensajeAlerta,
          life: 8000
        });
        // NO cerrar el formulario (el asesor debe poder reintentar)
        return;
      }

      // Caso exitoso: acta generada (o no aplica acta)
      this.messageService.add({
        severity: 'success',
        summary: 'Cumplimiento registrado',
        detail: 'La orientación no programada fue registrada correctamente.',
        life: 4000
      });
      if (response.idActa360) {
        this.nmconsecutivoCumplimientoDescargable = response.nmconsecutivo;
        this.mostrarBotonDescargarActa.set(true);
        this.messageService.add({
          severity: 'success',
          summary: 'Acta asociada',
          detail: `El acta ${response.idActa360} fue generada y asociada al cumplimiento.`,
          life: 4000
        });
        await this.buscar();
        return;
      }
      this.cerrarFormularioCumplimiento();
      await this.buscar();
    } catch (err: any) {
      const serverMessage: string =
        err?.error?.message ?? // { message: "..." } del body Spring
        err?.error?.detail ?? // { detail: "..." }
        err?.message ?? // mensaje genérico del HttpErrorResponse
        'No fue posible registrar el cumplimiento de la orientación.';
      this.messageService.add({
        severity: 'error',
        summary: 'Error al registrar cumplimiento',
        detail: serverMessage,
        life: 8000
      });
    } finally {
      this.loadingGuardarCumplimiento.set(false);
    }
  }

  async onVerHistorialCumplimientos(): Promise<void> {
    const consecutivoProgramacion =
      this.nmconsecutivoProgramacionActual ??
      this.programacionSeleccionada()?.nmconsecutivo ??
      null;
    if (!consecutivoProgramacion || consecutivoProgramacion <= 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sin historial',
        detail:
          'Esta orientación aún no tiene una programación asociada para consultar historial.',
        life: 5000
      });
      return;
    }

    try {
      const cumplimientos =
        await this.cumplimientoRepo.listarHistorialCumplimientos(
          consecutivoProgramacion
        );
      this.historialCumplimientos.set(cumplimientos);
      this.historialCumplimientosVisible.set(true);
    } catch {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar el historial de cumplimientos',
        life: 5000
      });
    }
  }

  /**
  * HU1132419 -> Reintenta la generación del acta 360 cuando falló en el save original.
   * Legacy: CreateOrUpdateCumplimientoActivity.generarNuevamenteActa() -> mostrarOcultarOpciones(3, false)
   */
  async onReintentarActa(datosActa?: DatosActaRequest): Promise<void> {
    if (this.actaGenerando()) {
      return;
    }

    const datosActaReintento = datosActa ?? this.ultimaDatosActa;
    if (!this.nmconsecutivoCumplimientoGuardado || !datosActaReintento) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'No hay datos del acta para reintentar.'
      });
      return;
    }

    this.ultimaDatosActa = datosActaReintento;
    this.actaGenerando.set(true);
    this.actaError.set(null);
    const nmconsecutivo = this.nmconsecutivoCumplimientoGuardado;
    try {
      const payload = {
        ...datosActaReintento,
        idCumplimiento: String(nmconsecutivo)
      };
      const result = await this.cumplimientoRepo.reintentarGenerarActa(
        nmconsecutivo,
        payload
      );
      this.actaGenerando.set(false);
      this.mostrarBotonReintentar.set(false);
      this.nmconsecutivoCumplimientoDescargable = nmconsecutivo;
      this.mostrarBotonDescargarActa.set(true);
      this.messageService.add({
        severity: 'success',
        summary: 'Acta generada',
        detail: `Acta generada exitosamente (ID: ${result.idActa360})`,
        life: 5000
      });
      await this.buscar();
    } catch (err: any) {
      this.actaGenerando.set(false);
      const msg =
        err?.error?.message ||
        err?.error?.detail ||
        err?.message ||
        'Error al reintentar la generación del acta';
      this.actaError.set(msg);
      this.messageService.add({
        severity: 'error',
        summary: 'Error al generar acta',
        detail: msg,
        life: 8000
      });
    }
  }

  async onDescargarActaAsociada(): Promise<void> {
    const nmconsecutivo = this.nmconsecutivoCumplimientoDescargable;
    if (!nmconsecutivo) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sin acta asociada',
        detail: 'No hay un acta asociada disponible para descargar.'
      });
      return;
    }

    this.descargandoActaAsociada.set(true);
    try {
      await this.cumplimientoRepo.descargarActaPdf(
        nmconsecutivo,
        `acta_${nmconsecutivo}.pdf`
      );
      this.messageService.add({
        severity: 'success',
        summary: 'Descarga iniciada',
        detail: 'El acta asociada se está descargando.'
      });
    } catch (error) {
      const mensaje =
        error instanceof Error
          ? error.message
          : 'No fue posible descargar el acta asociada.';
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: mensaje
      });
    } finally {
      this.descargandoActaAsociada.set(false);
    }
  }

  private mapearOrdenAProgramacion(
    orden: OrdenServicioDetalle
  ): ProgramacionPendiente {
    const idOrden = orden.nmconsecutivo ?? orden.nmconsecutivoTarea ?? 0;
    return {
      nmconsecutivo: (orden as any).nmconsecutivoProgramacion ?? 0,
      nmconsecOrdenServDetalle: idOrden,
      nmconsecutivoManualOrden: orden.nmconsecutivoManualOrden,
      dsnombreCliente: orden.nombreCliente || orden.nombreBeneficiario,
      // Para flujo NO_PROGRAMADA mostramos Aseguradora en el formulario; se rellena
      // con el valor retornado por el backend (si existe) o con el filtro seleccionado.
      dsnombreAseguradora:
        (orden as any).dsAseguradora || this.filtros.dsAseguradora || undefined,
      dsnombreBeneficiario: orden.nombreBeneficiario,
      dscentroTrabajo: orden.dsCentroTrabajo,
      dstarea: orden.dsServicio,
      dsnombreServicio: orden.dsNombreServicio || orden.dsProducto,
      dsnombreContacto: orden.dsNombrContactoBeneficiario,
      dsemailContacto: orden.dsEmailProfesional,
      dstipomanejo: orden.dstipomanejo,
      cdmunicipioOrigen: orden.cdmunicipioOrigen || orden.cdmunicipiOrigen,
      cdmunicipioEntrega: orden.cdmunicipioEntrega || orden.cdmunicipiEntrega,
      dsmunicipioOrigen: orden.dsMunicipioOrigen,
      dsmunicipioEntrega: orden.dsMunicipioEntrega,
      cdsuraOrigen: orden.cdsuraOrigen,
      cdsuraEntrega: orden.cdsuraEntrega,
      cdpoblacion: (orden as any).cdpoblacion || undefined,
      nmconsecutivoOficina: orden.nmconsecutivoOficina,
      nmconsecutivoCliente: orden.nmconsecutivoCliente,
      nmconsecutivoBeneficiario: orden.nmconsecutivobenef,
      nmconsecBenefCt: orden.nmconsecBenefCt,
      cdpersona: orden.cdpersonaCliente,
      nmcantidadProgramada: orden.nmcantidadPedida,
      saldoPorEjecutar: orden.saldoEjecutar,
      snprogramacionAutomatica: orden.snprogramacionAutomatica,
      snocautomatica: orden.snocautomatica,
      cdclasificacion: orden.cdclasificacion,
      dsclasificacion: orden.dsclasificacion
    };
  }

  verDetalleTarea(orden: OrdenServicioDetalle): void {
    // Legacy: DetalleTareaActivity.showModalDetalle(reglistaempresasRecord)
    this.ordenDetalle.set(orden);
    this.detalleTareaVisible = true;
  }

  verInfoEmpresa(orden: OrdenServicioDetalle): void {
    this.messageService.add({
      severity: 'info',
      summary: 'Información empresa',
      detail: 'Próximamente...',
      life: 4000
    });
  }

  formatFecha(fecha?: string): string {
    if (!fecha) return '';
    return fecha.replace(/-/g, '/');
  }

  textoTabla(valor: unknown): string {
    const texto = String(valor ?? '').trim();
    return texto || '-';
  }

  tituloTabla(valor: unknown): string {
    return String(valor ?? '').trim();
  }

  // === Handlers de fechas ===
  onFechaInicialChange(date: Date): void {
    this.filtros = { ...this.filtros, fechaInicial: this.toIsoDate(date) };
  }

  onFechaInicialClear(): void {
    this.filtros = { ...this.filtros, fechaInicial: undefined };
  }

  onFechaFinalChange(date: Date): void {
    this.filtros = { ...this.filtros, fechaFinal: this.toIsoDate(date) };
  }

  onFechaFinalClear(): void {
    this.filtros = { ...this.filtros, fechaFinal: undefined };
  }

  private toIsoDate(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  // === Handlers de diálogos ===
  async onBuscarAsesor(filtro: AsesorFiltro): Promise<void> {
    this.loadingAsesorBusqueda.set(true);
    try {
      const resultado = await this.personaRepo.getPageWithFilters(
        undefined,
        100,
        filtro
      );
      this.asesores.set(resultado.content);
    } catch {
      this.asesores.set([]);
    } finally {
      this.loadingAsesorBusqueda.set(false);
    }
  }

  onLimpiarBusquedaAsesor(): void {
    this.asesores.set([]);
  }

  seleccionarAsesorYCerrar(asesor: AsesorSeleccionado): void {
    const persona: Persona = {
      cdpersona: asesor.cdpersona,
      cdtipo_identificacion: asesor.cdtipoIdentificacion,
      nmidentificacion: asesor.nmidentificacion,
      dsnombre1: asesor.dsnombre1,
      dsnombre2: asesor.dsnombre2,
      dsapellido1: asesor.dsapellido1,
      dsapellido2: asesor.dsapellido2,
      dsnombre_comercial: asesor.dsnombreComercial,
      snactivo: asesor.snactivo
    };
    this.filtros = {
      ...this.filtros,
      nmconsecutivoAsesor: asesor.nmconsecutivo
    };
    this.asesorSeleccionado.set(persona);
    this.dialogBuscarAsesorVisible = false;
  }

  onAsesorSeleccionado(asesor: Persona | AsesorSeleccionado): void {
    if ('cdtipoIdentificacion' in asesor) {
      this.seleccionarAsesorYCerrar(asesor);
      return;
    }

    this.filtros = { ...this.filtros, nmconsecutivoAsesor: asesor.cdpersona };
    this.asesorSeleccionado.set(asesor);
    this.dialogBuscarAsesorVisible = false;
  }

  onClienteSeleccionado(cliente: ClienteSeleccionado): void {
    this.filtros = {
      ...this.filtros,
      cdpersonaCliente: cliente.cdpersona,
      nmconsecutivoBeneficiario: cliente.nmconsecutivo,
      dsBeneficiarioCliente: cliente.nombreComercial,
      // Limpiar CT al cambiar beneficiario/cliente
      nmconsecBenefCt: undefined,
      dsCentroTrabajo: undefined
    };
    this.dialogBuscarClienteVisible = false;
  }

  onUenSeleccionada(uen: UnidadAdministrativaSeleccionada): void {
    this.filtros = {
      ...this.filtros,
      cdunidadAdministrativa: uen.cdunidadAdministrativa,  // código que espera el backend
      dsUen: uen.dsunidadAdministrativa
    };
    this.dialogBuscarUenVisible = false;
  }

  onTareaSeleccionada(tarea: TareaSeleccionada): void {
    this.filtros = {
      ...this.filtros,
      nmconsecHomologacionServicio: tarea.nmconsecutivo,
      dsTarea: tarea.descripcionCompleta
    };
    this.dialogBuscarTareaVisible = false;
  }

  onCentroTrabajoSeleccionado(ct: CentroTrabajoSeleccionado): void {
    this.filtros = {
      ...this.filtros,
      nmconsecBenefCt: ct.nmconsecutivo,
      dsCentroTrabajo: ct.descripcionCompleta
    };
    this.dialogBuscarCtVisible = false;
  }

  // === Limpiar campos individuales ===
  limpiarAsesor(): void {
    this.filtros = { ...this.filtros, nmconsecutivoAsesor: undefined };
    this.asesorSeleccionado.set(null);
    this.asesores.set([]);
  }

  limpiarBeneficiarioCliente(): void {
    this.filtros = {
      ...this.filtros,
      cdpersonaCliente: undefined,
      nmconsecutivoBeneficiario: undefined,
      dsBeneficiarioCliente: undefined,
      nmconsecBenefCt: undefined,
      dsCentroTrabajo: undefined
    };
  }

  limpiarUen(): void {
    this.filtros = {
      ...this.filtros,
      cdunidadAdministrativa: undefined,
      dsUen: undefined
    };
  }

  limpiarTarea(): void {
    this.filtros = {
      ...this.filtros,
      nmconsecHomologacionServicio: undefined,
      dsTarea: undefined
    };
  }

  limpiarCentroTrabajo(): void {
    this.filtros = {
      ...this.filtros,
      nmconsecBenefCt: undefined,
      dsCentroTrabajo: undefined
    };
  }

  onAseguradoraSeleccionada(event: AseguradoraSeleccionada): void {
    this.filtros = {
      ...this.filtros,
      nmconsecutivoCliente: event.nmconsecutivo,
      dsAseguradora: event.nombreComercial
    };
    this.dialogBuscarAseguradoraVisible = false;
  }

  limpiarAseguradora(): void {
    this.filtros = {
      ...this.filtros,
      nmconsecutivoCliente: undefined,
      dsAseguradora: undefined
    };
  }
}
